import { BASE_URL, FORMAT_NUMBER, CURRENCY } from "../../libs/utils/Const";
import React, { Component } from "react";
import { io } from 'socket.io-client';
import $ from "jquery";

class NiubizModal extends Component {
    constructor(props) {
        super(props);
        this.socket = null;
    }

    componentDidMount() {
        const { payment, showAlert, addNiubizReference } = this.props;

        if (payment?.idNiubiz) {
            this.socket = io(BASE_URL.replace("/api", ""), { transports: ['websocket'], query: { role: 'counter' } });
            this.socket.on('connect', () => { console.log('D5>> socket connected!!'); });
            this.socket.emit('niubizOnHold', payment?.idNiubiz);
            this.socket.on('paymentStatus', async (data) => { // detectar cuando se hizo el pago
                if (data.status === 'SUCCESS') {
                    showAlert({ type: 'success', message: 'Pago realizado correctamente', timeOut: 5000 });
                    $("#niubizModal").modal("hide");
                    addNiubizReference(payment?.idNiubiz, data?.NiubizReference);
                }
            });
            this.socket.on('disconnect', () => { console.log('D5>> socket disconnected!!'); });
        }
    }

    render() {
        const { payment, RemovePaymentSaleByNiubiz } = this.props;

        return (
            <div className="modal" id="niubizModal" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 400 }}>
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <span className="h3 mb-2"> QR - NIUBIZ </span> <br />
                            <span className="h6"> Esperando respuesta del servicio </span>
                            <div className="p-5">
                                <img className="w-100" src={payment.imageSource || ""} alt="qrSource" />
                            </div>
                            <span className="h4"> Total: {payment.Amount != null ? `${CURRENCY} ${FORMAT_NUMBER.new(Number(payment.Amount))}` : ''}</span>
                        </div>
                        <div className="modal-footer">
                            <div className="col-sm-12">
                                <div className="m-2 row">
                                    {/* <button type="button" className="btn-lg btn-primary w-100" onClick={() => $("#niubizModal").modal("hide")}> Continuar </button> */}
                                    <button type="button" className="btn-lg btn-danger w-100" onClick={() => { $("#niubizModal").modal("hide"); if (payment?.idNiubiz) { RemovePaymentSaleByNiubiz(payment?.idNiubiz) } }}> Cerrar </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NiubizModal;